import { render, staticRenderFns } from "./block-activity.vue?vue&type=template&id=297339e4&scoped=true"
import script from "./block-activity.vue?vue&type=script&lang=js"
export * from "./block-activity.vue?vue&type=script&lang=js"
import style0 from "./block-activity.vue?vue&type=style&index=0&id=297339e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297339e4",
  null
  
)

export default component.exports